import GOOGLEMAP from '../plugins/googlemap_disp'
import GET_ARTICLES from '../plugins/getArticles';
import GET_INSTAGRAM from '../plugins/getInstagram';
import 'slick-carousel'


export default function HOME() {
  
  $(() => {
  
    /*****
     * Map追加
     */
    GOOGLEMAP()
  
    // トップページカスタム
    $.topInit();
  
    // ブロック整形
    (function(__){ $.each(__, $.topBlockCustomizer) }({
      'news':{
        button:{
          disp: true,
          text: 'VIEW ALL',
          attr:{
            class: 'button button-border-grey button-medium'
          }
        },
        title:{
          html: '<span>NEWS & BLOG</span><small>お知らせ</small>' // プレーンテキストで動的にする場合は false
        },
        category:{
          disp: true,
          opt:{
            content: 'news',
            blockClass: 'p-newsBlock__catlist',
            addAll: true,
            linkClass:'button button-border-grey button-small'
          }
        },
        itemlayout: function($this,$catetitle,$date,$new,$title,$catch,$body){
          $this
            .append( $title.append($new) )
            .append( $catetitle )
            .append( $date )
            .append( $catch )
            .append( $body );
          // $date.insertAfter( $catetitle );
        },
        cb: obj => obj.find('.artloop').each( (i,obj) => {
          $(obj).unwrap().wrapInner('<div class="artloop__body"/>')
          $('.artloop__body > table',obj).prependTo(obj)
        })
      },
    }));
    window.load['mainvisual'].done(()=>{
      
      /*****
       * Slick実行
       */
      $('[data-plugin="slider"]').slick({
        autoplay:true,
        fade: true,
        dots: true,
        speed: 1200,
        autoplaySpeed: 4000,
        pauseOnHover: false,
        pauseOnFocus: false,
        arrows: false,
        useCSS: false,
        useTransform: false
      })

      /*****
       * NewsTicker実行
       */
      $('[data-plugin="newsTicker"]').each(function(){
        const $self = $(this)
        $self.attr({
          'data-plugin': 'getArticles',
          'data-content': 'news',
          'data-module': 'content5',
          'data-amount': 1,
        })
        let makeItem = ( item, opt ) => {
          return $(`
            <p class="${opt.prefix}item">
              <a href="${item.category.href}">［${item.category.name}］</a>
              <a href="${item.href}">${item.title.str_truncate(19)}</a>
            </p>
          `)[0]
        }
        GET_ARTICLES('.p-ticker',{ makeItem })
      })
    })

    window.load['block-gallery'].done(()=> GET_ARTICLES('.p-block-gallery') )

    window.load['block-staff'].done(() => {
      GET_ARTICLES('.p-block-staff',{
        makeItem(item,opt) {
          return $(`
            <a href="${item.href}" class="${opt.prefix}__article">
              <img src="${item.thumb}" alt="${item.desc}" width="300">
              <p class="${opt.prefix}__name is-${window.siteinfo.sextable[item.id]||'male'}"><span>${item.desc.split('|')[0].replace(/^\s|\s$/m,'').replace(/\s+?/,'<br>')}</span></p>
            </a>`)[0]
        }
      }).done(() => {
        $('.p-block-staff__list').slick({
          autoplay: true,
          fade: false,
          speed: 1500,
          centerMode: false,
          pauseOnHover: false,
          pauseOnFocus: false,
          arrows: false,
          infinite: true,
          variableWidth: true,
          swipeToSlide:true,
          slidesToShow: 4,
          responsive: [{
            breakpoint: 768,
            settings: {
              slidesToShow: 3,
              centerMode: true
            }
          }]
        })
      })
      
    })

    window.load['block-instagram'].done(() => GET_INSTAGRAM().done(() => {
      $('.p-block-instagram__list').slick({
        autoplay: true,
        fade: false,
        speed: 1500,
        centerMode: false,
        pauseOnHover: false,
        pauseOnFocus: false,
        arrows: false,
        infinite: true,
        variableWidth: true,
        swipeToSlide:true,
        slidesToShow: 4,
        responsive: [{
          breakpoint: 768,
          settings: "unslick"
        }]
      })
    }))

  
  });
}